import { useState, useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import ViewContainer from "components/ViewContainer/ViewContainer";
import { sendActivateUserToken } from "services/http/users";

const ActivateUserToken = (props) => {
  const { search } = useLocation();
  const { enqueueSnackbar } = props;
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [responseText, setResponseText] = useState();

  const handleSendToken = useCallback(
    (token) => {
      const request = {
        data: {
          token: token,
        },
      };

      sendActivateUserToken(request).then(
        (_response) => {
          enqueueSnackbar(t("Onnistui"), { variant: "success" });
          setResponseText(t("Käyttäjätili on aktivoitu"));
          setLoading(false);
        },
        (_error) => {
          enqueueSnackbar(t("Epäonnistui"), { variant: "error" });
          setResponseText(t("Tilin aktivointi epäonnistui"));
          setLoading(false);
        },
      );
    },
    [enqueueSnackbar, t],
  );

  useEffect(() => {
    if (!search) {
      setResponseText(t("Virheellinen tai puuttuva aktivointilinkki"));
      setLoading(false);
      return;
    }
    const parsed = queryString.parse(search);
    if (parsed.token) {
      handleSendToken(parsed.token);
    } else {
      setResponseText(t("Virheellinen tai puuttuva aktivointilinkki"));
      setLoading(false);
    }
  }, [search, handleSendToken, t]);

  return (
    <ViewContainer title={t("Käyttäjätilin aktivointi")}>
      <Grid
        container
        direction="row"
        sx={{ justifyContent: "center", alignItems: "center" }}
      >
        <Grid size={12}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Typography>{responseText}</Typography>
          )}
        </Grid>
      </Grid>
    </ViewContainer>
  );
};

export default ActivateUserToken;
